<script lang="ts">
	import type { Zoi } from '$lib/components/zoi/types';
	import defaultPoiImage from '$assets/pois/default.webp';
	import Image from '$lib/components/atoms/image/Image.svelte';
	import ButtonMarker from '$lib/components/map/markers/ButtonMarker.svelte';

	interface Props {
		zoi: Zoi;
		onclick?: (zoi: Zoi) => void;
		dataTestId: string;
	}

	const { zoi, onclick, dataTestId = 'zoi-marker' }: Props = $props();

	function handleMarkerClick() {
		onclick?.(zoi);
	}

	const srcset = $derived(zoi.images
		? Object.entries(zoi.images)
			.filter(([width]) => width.startsWith('w'))
			.map(([width, src]) => `${src} ${width.replace('w', '')}w`)
			.join(', ')
		: undefined);
</script>

<ButtonMarker
	lngLat={[zoi.center.lng, zoi.center.lat]}
	markerOptions={{
		anchor: 'center',
	}}
	class="rd-full bg-transparent w-11 h-11 border-4 border-solid border-neutral-weakest shadow-drop"
	ariaLabel={zoi.name}
	onclick={handleMarkerClick}
	{dataTestId}
>
	<Image
		src={zoi.images?.w160 ?? defaultPoiImage}
		{srcset}
		sizes="160px"
		alt={zoi.name}
		class="object-cover w-full h-full rd-full"
		fallbackSrc={defaultPoiImage}
	/>
</ButtonMarker>
